
const digest = '3c509d32b7b01ad4e77a1beb583336fb0e08d98a62c7788db1e25974b25bd803';
const classes = {"wrapper":"_wrapper_1qsl8_1"};
const css = `._wrapper_1qsl8_1 {
  height: 100%;
  overflow-y: visible;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  